/**
 * Get the Klarna payment method code for the current country code.
 */
export function getKlarnaPaymentMethodCode(
  countryCode?: string,
): string | undefined {
  switch (countryCode) {
    case "SE":
      return "klarna-checkout-se";
    case "GB":
      return "klarna-checkout-uk";
    case "AU":
      return "klarna-checkout-au";
    case "US":
      return "klarna-checkout-us";
    case "NZ":
      return "klarna-checkout-nz";
    case "NO":
      return "klarna-checkout-no";
    case "CA":
      return "klarna-checkout-ca";
    case "CL":
      return "klarna-checkout-cl";
    case "DK":
      return "klarna-checkout-dk";
    case "DE":
      return "klarna-checkout-de";
    case "ES":
      return "klarna-checkout-es";
    case "FR":
      return "klarna-checkout-fr";
    case "IT":
      return "klarna-checkout-it";
    case "NL":
      return "klarna-checkout-nl";
    case "IE":
      return "klarna-checkout-ie";
    case "FI":
      return "klarna-checkout-fi";
    case "AT":
      return "klarna-checkout-at";
    default:
      return "klarna-checkout-row";
  }
}
